import Fund from '@/types/fund';
import { AsyncResult, Action, ApiAction, Result } from '../../index';
import api from '../../redux-api';

// Types
import { SavedFundsState } from '../types/saved-funds';

// Initial State
const INITIAL_STATE: SavedFundsState = {
  funds: [],
  loading: false,
};

// Actions
const MY_FUNDS_GET_ALL: ApiAction = {
  type: 'connect/funds/saved-funds/get-all',
  endpoint: 'users/my-funds',
};

const MY_FUNDS_ADD: ApiAction = {
  type: 'connect/funds/saved-funds/add',
  endpoint: 'users/my-funds',
};

const MY_FUNDS_DELETE: ApiAction = {
  type: 'connect/funds/saved-funds/delete',
  endpoint: 'users/my-funds/:id/',
};

const UPDATE_SAVED_FUNDS: Action = {
  type: 'connect/funds/saved-funds/update',
};

// Reducer
export default function reducer(state: SavedFundsState = INITIAL_STATE, action: Action): SavedFundsState {
  switch (action.type) {
    case MY_FUNDS_GET_ALL.type: {
      return {
        ...state,
        funds: [],
        loading: true,
      };
    }
    case `${MY_FUNDS_GET_ALL.type}_SUCCESS`: {
      return {
        ...state,
        // View CONN-389 for context -- it's a temporary workaround until the backend issues are sorted out.
        funds: action.data.data || [],
        loading: false,
      };
    }
    case `${MY_FUNDS_GET_ALL.type}_ERROR`: {
      return {
        ...state,
        loading: false,
      };
    }
    case UPDATE_SAVED_FUNDS.type: {
      return {
        ...state,
        funds: action.funds,
      };
    }
    case MY_FUNDS_ADD.type:
      return {
        ...state,
        funds: [...state.funds, ...action.payload.funds],
      };
    case `${MY_FUNDS_ADD.type}_ERROR`:
      return {
        ...state,
        funds: state.funds.filter(f => !action.payload.funds.includes(f._id)),
      };
    case MY_FUNDS_DELETE.type:
      return {
        ...state,
        funds: state.funds.filter(f => f._id !== action.id),
      };
    default:
      return state;
  }
}

// Action Creators
export const getSavedFunds = (): AsyncResult<Fund[]> => () => api.get(MY_FUNDS_GET_ALL).then((res: { data: any }) => res.data);

export const updateSavedFunds =
  (funds: Fund[]): Result<Fund[]> =>
  dispatch => {
    dispatch({ type: UPDATE_SAVED_FUNDS.type, funds });

    return funds;
  };

export const toggleSavedFund =
  (fund: Fund): AsyncResult<Fund[]> =>
  (dispatch, getState) => {
    const savedFunds = getState().funds.savedFunds.funds;

    if (savedFunds.some(f => f._id === fund._id)) {
      return api.delete(MY_FUNDS_DELETE, { id: fund._id }).catch((response: { status: any }) => {
        // Add fund back to the state if there was an unhandled error
        // 404 means it's already out of the user's saved funds, so don't re-add it
        if (response.status !== 404) {
          dispatch({ type: MY_FUNDS_ADD.type, payload: { funds: [fund] } });
        }

        throw response;
      });
    }

    return api.post(MY_FUNDS_ADD, {}, { funds: [fund] });
  };
